export default "__VITE_ASSET__04kZqXOc__"